import * as React from 'react';
import { Text, Label, Stack, Toggle, ProgressIndicator, PrimaryButton, DefaultButton, MessageBar } from '@fluentui/react';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IUserRoles } from '../../../../Models/Admin/IUserRoles';


interface IUserPropertiesRolesProps {
    roles: IUserRoles;
    isLoading: boolean;
    statusMessage?: IStatusMessage;
    changeInfoProperty: (key: string, value: any) => void;
    onDismiss: () => void;
    onSave: () => void;
}

export const UserPropertiesRoles: React.FunctionComponent<IUserPropertiesRolesProps> = (props) => {

    const roleChanged = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, checked ? true:false);
        }
    }


    return (<Stack>
        <Stack horizontal>
            <Stack horizontal verticalAlign="center">
                <Text styles={{ root: { fontWeight: 600 } }} variant="xLargePlus">
                    Role uživatele
                </Text>
            </Stack>
            </Stack>
             <Stack tokens={{ childrenGap:15 }} styles={{ root: { paddingTop: 40 } }}>
            <Stack>
                <Toggle disabled={props.isLoading} id="teacher" key="teacher" onChange={roleChanged} checked={props.roles.teacher} styles={{ root: { marginBottom: 0 } }} label="Učitel" inlineLabel />
                    <Text>Učitel má přístup ke kurzům ke kterým je přiřazen</Text>
                </Stack>
            <Stack>
                <Toggle disabled={props.isLoading} id="accountant" key="accountant"  onChange={roleChanged} checked={props.roles.accountant} styles={{ root: { marginBottom: 0 } }} label="Účetní" inlineLabel />
                    <Text>Účetní má přístup k vystavování faktrur</Text>
                </Stack>
            <Stack>
                <Toggle disabled={props.isLoading} id="admin" key="admin"  onChange={roleChanged} checked={props.roles.admin} styles={{ root: { marginBottom: 0 } }} label="Admin" inlineLabel />                
                    <Text>Maximální opravnění</Text>
                </Stack>
            </Stack>
        <Stack styles={{ root: { height: 10 } }}>
            {props.isLoading ? <ProgressIndicator /> : null}
        </Stack>
        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
            <PrimaryButton onClick={props.onSave}>Uložit</PrimaryButton>
            <DefaultButton onClick={props.onDismiss}>Zavřít</DefaultButton>
        </Stack>
        {props.statusMessage && props.statusMessage.message ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
           </Stack>);
}